import { Money } from '@percent/cause-dashboard/common/utility/money/money.types'

export enum PayoutStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  RETURNED = 'RETURNED'
}

export type Payout = {
  id: string
  organisationId: string
  netAmount: number
  paidAmount: number
  netCurrencyCode: string
  paidCurrencyCode: string
  reference: string
  status: PayoutStatus
  createdAt: string
  paidAt: string
}

export type DonationWithFees = {
  id: string
  organisationId: string
  partnerId: string
  partner?: {
    name?: string
  }
  amount: Money
  settledAmount?: Money
  createdAt: string
  fee?: {
    grossAmount: Money
    feeAmount: Money
  }
  firstName?: string
  lastName?: string
  email?: string
  consentedToBeContactedByOrg: 'yes' | 'no' | null
  giftNote: string | null
}

export type GetPayoutsListProps = {
  pageSize?: number | null
  'expand[]'?: string
  cursor?: string
}
